const FT = 'FT';
const PN = 'PN';
const PJ = 'PJ';
const MENOR_QUE = '<';
const MAYOR_QUE = '>';
const MENOR_IGUAL_QUE = '<=';
const MAYOR_IGUAL_QUE = '>=';
const IGUAL_QUE = '==';
const DIFERENTE_DE = '!=';
const P = 'P';
const V = 'V';
const I = 'I';
const B = 'B';
const C = 'C';
const T = 'T';
const SE = 'SE';
const CT = 'CT';
const CP = 'CP';
const PD = 'PD';
const VT = 'VT';
const EP = 'EP';
const LISTA_EMPAQUE = 'LE';
const RECEPCION = 'RP';
const NC = 'NC';
const ND = 'ND';
const BO = 'BO';
const C39 = 'C39';
const CL = 'CL';
const D = 'D';
const E = 'E';
const E128 = 'E128';
const E13 = 'E13';
const E14 = 'E14';
const E8 = 'E8';
const EA = 'EA';
const EB = 'EB';
const F = 'F';
const GT = 'GT';
const H = 'H';
const L = 'L';
const M = 'M';
const N = 'N';
const PR = 'PR';
const R = 'R';
const S = 'S';
const TR = 'TR';
const U12 = 'U12';
const U8 = 'U8';
const RD = 'RD';
const RR = 'RR';
const VE = 'VE';
const FIELD_TYPE_TEXT = 'Texto';
const FIELD_TYPE_SELECT = 'Selección';
const FIELD_TYPE_NUMBER = 'Número';
const FIELD_TYPE_LOGIC = 'Lógico';
const FIELD_TYPE_DATE = 'Fecha';
const MODELO_MANAGER = 'MM';
const MANAGER = 'M';
const WALLET = 'W';
const CUENTA_BANCARIA = 'CB';
const AHORROS = 'AH';
const CORRIENTE = 'CO';
const MASCULINO = 'MA';
const FEMENINO = 'F';
const FIELD_TYPE_TIME = 'TI';
const FIELD_TYPE_PERCENT = 'P';
const FIELD_TYPE_NUMBERM = 'NM';

export default {
  B,
  FT,
  NC,
  ND,
  BO,
  C,
  PD,
  C39,
  CL,
  CT,
  VT,
  D,
  E,
  E128,
  E13,
  E14,
  E8,
  EA,
  EB,
  F,
  GT,
  H,
  EP,
  I,
  L,
  SE,
  LISTA_EMPAQUE,
  M,
  N,
  P,
  PJ,
  PN,
  PR,
  R,
  S,
  T,
  TR,
  U12,
  U8,
  V,
  CP,
  MENOR_IGUAL_QUE,
  MENOR_QUE,
  MAYOR_IGUAL_QUE,
  MAYOR_QUE,
  DIFERENTE_DE,
  IGUAL_QUE,
  RECEPCION,
  RD,
  RR,
  VE,

  FIELD_TYPE_TEXT,
  FIELD_TYPE_SELECT,
  FIELD_TYPE_NUMBER,
  FIELD_TYPE_LOGIC,
  FIELD_TYPE_DATE,
  FIELD_TYPE_TIME,
  FIELD_TYPE_NUMBERM,
  FIELD_TYPE_PERCENT,

  MODELO_MANAGER,
  MANAGER,

  WALLET,
  CUENTA_BANCARIA,

  AHORROS,
  CORRIENTE,

  MASCULINO,
  FEMENINO,
};
